import React from 'react';
import StepSection from '../../../../Elements/StepSection';
import SettingRows from '../../../../Elements/SettingRows';
import Timeline from '../../../../Elements/Timeline';
import InlineSelect from '../../../../Elements/InputComponents/BaseInputs/InlineSelect';
import InvoiceAutomationRunScheduleSentenceOptionsArray from '../../../../Enums/InvoiceAutomationRunScheduleSentenceOptionsArray';
import InvoiceAutomationJobMonthRuleSentenceOptionsArray from '../../../../Enums/InvoiceAutomationJobMonthRuleSentenceOptionsArray';
import { getFirstMonthOptions } from '../../../../Helpers/invoiceAutomationMonthHelper';
import {
  getJobMonthNote,
  getMonthTimeline,
  getRunScheduleNote,
} from '../../../../Helpers/invoiceAutomationSetupPageHelper';

// Step 1 of the setup page: when Bravo works on the drafts and which month a job belongs to, as sentences whose
// choices are saved as soon as they are picked (onChange gets the changed setting), and a month under those rules.
export default function InvoiceAutomationWhenStep({ setup = null, isDisabled = false, onChange = (changes) => {} }) {
  const rows = [
    {
      label: 'Runs',
      content: (
        <>
          Bravo prepares this project&apos;s draft invoices{' '}
          <InlineSelect
            value={setup.RunSchedule}
            options={InvoiceAutomationRunScheduleSentenceOptionsArray}
            label='Runs'
            disabled={isDisabled}
            onChange={(runSchedule) => onChange({ RunSchedule: runSchedule })}
          />
          .
        </>
      ),
      note: getRunScheduleNote(setup.RunSchedule),
    },
    {
      label: 'A job’s month',
      content: (
        <>
          Each job goes on the draft of the month{' '}
          <InlineSelect
            value={setup.JobMonthRule}
            options={InvoiceAutomationJobMonthRuleSentenceOptionsArray}
            label='A job belongs to the month'
            disabled={isDisabled}
            onChange={(jobMonthRule) => onChange({ JobMonthRule: jobMonthRule })}
          />
          .
        </>
      ),
      note: getJobMonthNote(setup.JobMonthRule),
    },
    {
      label: 'First month',
      content: (
        <>
          Bravo starts with{' '}
          <InlineSelect
            value={setup.FirstMonth}
            options={getFirstMonthOptions(new Date(), setup.FirstMonth)}
            label='First month'
            disabled={isDisabled}
            onChange={(firstMonth) => onChange({ FirstMonth: firstMonth })}
          />
          .
        </>
      ),
      note: 'Jobs of earlier months are out of scope: invoice them by hand, or bring them in with Run Now.',
    },
  ];

  return (
    <StepSection
      number={1}
      title='When'
      lead="When Bravo works on this project's invoices, and which month a job belongs to."
    >
      <SettingRows rows={rows}>
        <Timeline events={getMonthTimeline(setup.JobMonthRule, setup.RunSchedule)} />
      </SettingRows>
    </StepSection>
  );
}
